import React from "react";
import { Form, Select } from "antd";
import { CHOICE_ANSWER_TYPES } from "./questionEnums";
import { normalizeAnswerOptionsForForm } from "./utils";

export default function AnswerOptionsField({
  name = "answerOptions",
  answerTypeName = "answerType",
}) {
  return (
    <Form.Item noStyle shouldUpdate={(prev, cur) => prev?.[answerTypeName] !== cur?.[answerTypeName]}>
      {({ getFieldValue }) => {
        const answerType = getFieldValue(answerTypeName);
        const isChoice = CHOICE_ANSWER_TYPES.includes(answerType);

        return (
          <Form.Item
            name={name}
            label="Answer Options"
            valuePropName="value"
            rules={
              isChoice
                ? [
                    {
                      validator: async (_, value) => {
                        const normalized = normalizeAnswerOptionsForForm(value);
                        if (!normalized.length) {
                          throw new Error("Add at least one answer option");
                        }
                      },
                    },
                  ]
                : []
            }
            extra={
              isChoice
                ? "Type an option and press Enter or comma. Use the chips to add multiple values."
                : "Optional unless the answer type is a choice type."
            }
          >
            <Select
              mode="tags"
              tokenSeparators={[","]}
              placeholder={isChoice ? "Add answer options" : "Add optional answer options"}
              maxTagCount="responsive"
            />
          </Form.Item>
        );
      }}
    </Form.Item>
  );
}
